import { Input, Loader, SettingsForm } from '@southfields-digital/mpxlive-components';
import { useContext, useEffect, useState } from 'react';
import { NavigateFunction, useNavigate } from 'react-router-dom';

import { BaseLayoutContext, BaseLayoutContextType } from 'src/layouts/BaseLayout';
import menuGroups from 'src/pages/Settings/menuGroups';

import styles from './CanvasFormPage.module.scss';

type CanvasFormPageProps = {
  createCanvas: (name: string, navigate: NavigateFunction) => void;
  submitting: boolean;
};

export default function CanvasFormPage({ createCanvas, submitting }: CanvasFormPageProps) {
  const navigate = useNavigate();
  const [name, setName] = useState<string>('');
  const { setWithContainer } = useContext<BaseLayoutContextType | null>(
    BaseLayoutContext
  ) as BaseLayoutContextType;

  useEffect(() => {
    setWithContainer(true);

    return function unmount() {
      setWithContainer(false);
    };
  }, []);

  return (
    <SettingsForm
      title="Create canvas"
      formSections={[
        {
          actions: [
            {
              children: <>{submitting && <Loader className={styles.Spinner} />} Create canvas</>,
              className: styles.CanvasFormSubmitButton,
              disabled: submitting || !name,
              onClick: () => createCanvas(name, navigate),
            },
          ],
          type: 'form',
          form: (
            <div className="flex flex-col gap-5">
              <Input
                type="text"
                value={name}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setName(e.target.value)}
                placeholder="Pick a recognisable name for your canvas"
              />
            </div>
          ),
        },
      ]}
      menuGroups={menuGroups}
    />
  );
}
